export const countries = [
    {
        name: "Afghanistan",
        dialCode: "+93",
        isoCode2: "AF",
        isoCode3: "AFG",
        flag: "🇦🇫",
    },
    {
        name: "Albania",
        dialCode: "+355",
        isoCode2: "AL",
        isoCode3: "ALB",
        flag: "🇦🇱",
    },
    {
        name: "Algeria",
        dialCode: "+213",
        isoCode2: "DZ",
        isoCode3: "DZA",
        flag: "🇩🇿",
    },
    {
        name: "American Samoa",
        dialCode: "+1684",
        isoCode2: "AS",
        isoCode3: "ASM",
        flag: "🇦🇸",
    },
    {
        name: "Andorra",
        dialCode: "+376",
        isoCode2: "AD",
        isoCode3: "AND",
        flag: "🇦🇩",
    },
    {
        name: "Angola",
        dialCode: "+244",
        isoCode2: "AO",
        isoCode3: "AGO",
        flag: "🇦🇴",
    },
    {
        name: "Anguilla",
        dialCode: "+1264",
        isoCode2: "AI",
        isoCode3: "AIA",
        flag: "🇦🇮",
    },
    {
        name: "Antarctica",
        dialCode: "+672",
        isoCode2: "AQ",
        isoCode3: "ATA",
        flag: "🇦🇶",
    },
    {
        name: "Antigua and Barbuda",
        dialCode: "+1268",
        isoCode2: "AG",
        isoCode3: "ATG",
        flag: "🇦🇬",
    },
    {
        name: "Argentina",
        dialCode: "+54",
        isoCode2: "AR",
        isoCode3: "ARG",
        flag: "🇦🇷",
    },
    {
        name: "Armenia",
        dialCode: "+374",
        isoCode2: "AM",
        isoCode3: "ARM",
        flag: "🇦🇲",
    },
    {
        name: "Aruba",
        dialCode: "+297",
        isoCode2: "AW",
        isoCode3: "ABW",
        flag: "🇦🇼",
    },
    {
        name: "Australia",
        dialCode: "+61",
        isoCode2: "AU",
        isoCode3: "AUS",
        flag: "🇦🇺",
    },
    {
        name: "Austria",
        dialCode: "+43",
        isoCode2: "AT",
        isoCode3: "AUT",
        flag: "🇦🇹",
    },
    {
        name: "Azerbaijan",
        dialCode: "+994",
        isoCode2: "AZ",
        isoCode3: "AZE",
        flag: "🇦🇿",
    },
    {
        name: "Bahamas",
        dialCode: "+1242",
        isoCode2: "BS",
        isoCode3: "BHS",
        flag: "🇧🇸",
    },
    {
        name: "Bahrain",
        dialCode: "+973",
        isoCode2: "BH",
        isoCode3: "BHR",
        flag: "🇧🇭",
    },
    {
        name: "Bangladesh",
        dialCode: "+880",
        isoCode2: "BD",
        isoCode3: "BGD",
        flag: "🇧🇩",
    },
    {
        name: "Barbados",
        dialCode: "+1246",
        isoCode2: "BB",
        isoCode3: "BRB",
        flag: "🇧🇧",
    },
    {
        name: "Belarus",
        dialCode: "+375",
        isoCode2: "BY",
        isoCode3: "BLR",
        flag: "🇧🇾",
    },
    {
        name: "Belgium",
        dialCode: "+32",
        isoCode2: "BE",
        isoCode3: "BEL",
        flag: "🇧🇪",
    },
    {
        name: "Belize",
        dialCode: "+501",
        isoCode2: "BZ",
        isoCode3: "BLZ",
        flag: "🇧🇿",
    },
    {
        name: "Benin",
        dialCode: "+229",
        isoCode2: "BJ",
        isoCode3: "BEN",
        flag: "🇧🇯",
    },
    {
        name: "Bermuda",
        dialCode: "+1441",
        isoCode2: "BM",
        isoCode3: "BMU",
        flag: "🇧🇲",
    },
    {
        name: "Bhutan",
        dialCode: "+975",
        isoCode2: "BT",
        isoCode3: "BTN",
        flag: "🇧🇹",
    },
    {
        name: "Bolivia",
        dialCode: "+591",
        isoCode2: "BO",
        isoCode3: "BOL",
        flag: "🇧🇴",
    },
    {
        name: "Bosnia and Herzegovina",
        dialCode: "+387",
        isoCode2: "BA",
        isoCode3: "BIH",
        flag: "🇧🇦",
    },
    {
        name: "Botswana",
        dialCode: "+267",
        isoCode2: "BW",
        isoCode3: "BWA",
        flag: "🇧🇼",
    },
    {
        name: "Brazil",
        dialCode: "+55",
        isoCode2: "BR",
        isoCode3: "BRA",
        flag: "🇧🇷",
    },
    {
        name: "British Indian Ocean Territory",
        dialCode: "+246",
        isoCode2: "IO",
        isoCode3: "IOT",
        flag: "🇮🇴",
    },
    {
        name: "British Virgin Islands",
        dialCode: "+1284",
        isoCode2: "VG",
        isoCode3: "VGB",
        flag: "🇻🇬",
    },
    {
        name: "Brunei",
        dialCode: "+673",
        isoCode2: "BN",
        isoCode3: "BRN",
        flag: "🇧🇳",
    },
    {
        name: "Bulgaria",
        dialCode: "+359",
        isoCode2: "BG",
        isoCode3: "BGR",
        flag: "🇧🇬",
    },
    {
        name: "Burkina Faso",
        dialCode: "+226",
        isoCode2: "BF",
        isoCode3: "BFA",
        flag: "🇧🇫",
    },
    {
        name: "Burundi",
        dialCode: "+257",
        isoCode2: "BI",
        isoCode3: "BDI",
        flag: "🇧🇮",
    },
    {
        name: "Cambodia",
        dialCode: "+855",
        isoCode2: "KH",
        isoCode3: "KHM",
        flag: "🇰🇭",
    },
    {
        name: "Cameroon",
        dialCode: "+237",
        isoCode2: "CM",
        isoCode3: "CMR",
        flag: "🇨🇲",
    },
    {
        name: "Canada",
        dialCode: "+1",
        isoCode2: "CA",
        isoCode3: "CAN",
        flag: "🇨🇦",
    },
    {
        name: "Cape Verde",
        dialCode: "+238",
        isoCode2: "CV",
        isoCode3: "CPV",
        flag: "🇨🇻",
    },
    {
        name: "Cayman Islands",
        dialCode: "+1345",
        isoCode2: "KY",
        isoCode3: "CYM",
        flag: "🇰🇾",
    },
    {
        name: "Central African Republic",
        dialCode: "+236",
        isoCode2: "CF",
        isoCode3: "CAF",
        flag: "🇨🇫",
    },
    {
        name: "Chad",
        dialCode: "+235",
        isoCode2: "TD",
        isoCode3: "TCD",
        flag: "🇹🇩",
    },
    {
        name: "Chile",
        dialCode: "+56",
        isoCode2: "CL",
        isoCode3: "CHL",
        flag: "🇨🇱",
    },
    {
        name: "China",
        dialCode: "+86",
        isoCode2: "CN",
        isoCode3: "CHN",
        flag: "🇨🇳",
    },
    {
        name: "Christmas Island",
        dialCode: "+61",
        isoCode2: "CX",
        isoCode3: "CXR",
        flag: "🇨🇽",
    },
    {
        name: "Cocos Islands",
        dialCode: "+61",
        isoCode2: "CC",
        isoCode3: "CCK",
        flag: "🇨🇨",
    },
    {
        name: "Colombia",
        dialCode: "+57",
        isoCode2: "CO",
        isoCode3: "COL",
        flag: "🇨🇴",
    },
    {
        name: "Comoros",
        dialCode: "+269",
        isoCode2: "KM",
        isoCode3: "COM",
        flag: "🇰🇲",
    },
    {
        name: "Cook Islands",
        dialCode: "+682",
        isoCode2: "CK",
        isoCode3: "COK",
        flag: "🇨🇰",
    },
    {
        name: "Costa Rica",
        dialCode: "+506",
        isoCode2: "CR",
        isoCode3: "CRI",
        flag: "🇨🇷",
    },
    {
        name: "Croatia",
        dialCode: "+385",
        isoCode2: "HR",
        isoCode3: "HRV",
        flag: "🇭🇷",
    },
    {
        name: "Cuba",
        dialCode: "+53",
        isoCode2: "CU",
        isoCode3: "CUB",
        flag: "🇨🇺",
    },
    {
        name: "Curacao",
        dialCode: "+599",
        isoCode2: "CW",
        isoCode3: "CUW",
        flag: "🇨🇼",
    },
    {
        name: "Cyprus",
        dialCode: "+357",
        isoCode2: "CY",
        isoCode3: "CYP",
        flag: "🇨🇾",
    },
    {
        name: "Czech Republic",
        dialCode: "+420",
        isoCode2: "CZ",
        isoCode3: "CZE",
        flag: "🇨🇿",
    },
    {
        name: "Democratic Republic of the Congo",
        dialCode: "+243",
        isoCode2: "CD",
        isoCode3: "COD",
        flag: "🇨🇩",
    },
    {
        name: "Denmark",
        dialCode: "+45",
        isoCode2: "DK",
        isoCode3: "DNK",
        flag: "🇩🇰",
    },
    {
        name: "Djibouti",
        dialCode: "+253",
        isoCode2: "DJ",
        isoCode3: "DJI",
        flag: "🇩🇯",
    },
    {
        name: "Dominica",
        dialCode: "+1767",
        isoCode2: "DM",
        isoCode3: "DMA",
        flag: "🇩🇲",
    },
    {
        name: "East Timor",
        dialCode: "+670",
        isoCode2: "TL",
        isoCode3: "TLS",
        flag: "🇹🇱",
    },
    {
        name: "Ecuador",
        dialCode: "+593",
        isoCode2: "EC",
        isoCode3: "ECU",
        flag: "🇪🇨",
    },
    {
        name: "Egypt",
        dialCode: "+20",
        isoCode2: "EG",
        isoCode3: "EGY",
        flag: "🇪🇬",
    },
    {
        name: "El Salvador",
        dialCode: "+503",
        isoCode2: "SV",
        isoCode3: "SLV",
        flag: "🇸🇻",
    },
    {
        name: "Equatorial Guinea",
        dialCode: "+240",
        isoCode2: "GQ",
        isoCode3: "GNQ",
        flag: "🇬🇶",
    },
    {
        name: "Eritrea",
        dialCode: "+291",
        isoCode2: "ER",
        isoCode3: "ERI",
        flag: "🇪🇷",
    },
    {
        name: "Estonia",
        dialCode: "+372",
        isoCode2: "EE",
        isoCode3: "EST",
        flag: "🇪🇪",
    },
    {
        name: "Ethiopia",
        dialCode: "+251",
        isoCode2: "ET",
        isoCode3: "ETH",
        flag: "🇪🇹",
    },
    {
        name: "Falkland Islands",
        dialCode: "+500",
        isoCode2: "FK",
        isoCode3: "FLK",
        flag: "🇫🇰",
    },
    {
        name: "Faroe Islands",
        dialCode: "+298",
        isoCode2: "FO",
        isoCode3: "FRO",
        flag: "🇫🇴",
    },
    {
        name: "Fiji",
        dialCode: "+679",
        isoCode2: "FJ",
        isoCode3: "FJI",
        flag: "🇫🇯",
    },
    {
        name: "Finland",
        dialCode: "+358",
        isoCode2: "FI",
        isoCode3: "FIN",
        flag: "🇫🇮",
    },
    {
        name: "France",
        dialCode: "+33",
        isoCode2: "FR",
        isoCode3: "FRA",
        flag: "🇫🇷",
    },
    {
        name: "French Polynesia",
        dialCode: "+689",
        isoCode2: "PF",
        isoCode3: "PYF",
        flag: "🇵🇫",
    },
    {
        name: "Gabon",
        dialCode: "+241",
        isoCode2: "GA",
        isoCode3: "GAB",
        flag: "🇬🇦",
    },
    {
        name: "Gambia",
        dialCode: "+220",
        isoCode2: "GM",
        isoCode3: "GMB",
        flag: "🇬🇲",
    },
    {
        name: "Georgia",
        dialCode: "+995",
        isoCode2: "GE",
        isoCode3: "GEO",
        flag: "🇬🇪",
    },
    {
        name: "Germany",
        dialCode: "+49",
        isoCode2: "DE",
        isoCode3: "DEU",
        flag: "🇩🇪",
    },
    {
        name: "Ghana",
        dialCode: "+233",
        isoCode2: "GH",
        isoCode3: "GHA",
        flag: "🇬🇭",
    },
    {
        name: "Gibraltar",
        dialCode: "+350",
        isoCode2: "GI",
        isoCode3: "GIB",
        flag: "🇬🇮",
    },
    {
        name: "Greece",
        dialCode: "+30",
        isoCode2: "GR",
        isoCode3: "GRC",
        flag: "🇬🇷",
    },
    {
        name: "Greenland",
        dialCode: "+299",
        isoCode2: "GL",
        isoCode3: "GRL",
        flag: "🇬🇱",
    },
    {
        name: "Grenada",
        dialCode: "+1473",
        isoCode2: "GD",
        isoCode3: "GRD",
        flag: "🇬🇩",
    },
    {
        name: "Guam",
        dialCode: "+1671",
        isoCode2: "GU",
        isoCode3: "GUM",
        flag: "🇬🇺",
    },
    {
        name: "Guatemala",
        dialCode: "+502",
        isoCode2: "GT",
        isoCode3: "GTM",
        flag: "🇬🇹",
    },
    {
        name: "Guernsey",
        dialCode: "+441481",
        isoCode2: "GG",
        isoCode3: "GGY",
        flag: "🇬🇬",
    },
    {
        name: "Guinea",
        dialCode: "+224",
        isoCode2: "GN",
        isoCode3: "GIN",
        flag: "🇬🇳",
    },
    {
        name: "Guinea-Bissau",
        dialCode: "+245",
        isoCode2: "GW",
        isoCode3: "GNB",
        flag: "🇬🇼",
    },
    {
        name: "Guyana",
        dialCode: "+592",
        isoCode2: "GY",
        isoCode3: "GUY",
        flag: "🇬🇾",
    },
    {
        name: "Haiti",
        dialCode: "+509",
        isoCode2: "HT",
        isoCode3: "HTI",
        flag: "🇭🇹",
    },
    {
        name: "Honduras",
        dialCode: "+504",
        isoCode2: "HN",
        isoCode3: "HND",
        flag: "🇭🇳",
    },
    {
        name: "Hong Kong",
        dialCode: "+852",
        isoCode2: "HK",
        isoCode3: "HKG",
        flag: "🇭🇰",
    },
    {
        name: "Hungary",
        dialCode: "+36",
        isoCode2: "HU",
        isoCode3: "HUN",
        flag: "🇭🇺",
    },
    {
        name: "Iceland",
        dialCode: "+354",
        isoCode2: "IS",
        isoCode3: "ISL",
        flag: "🇮🇸",
    },
    {
        name: "India",
        dialCode: "+91",
        isoCode2: "IN",
        isoCode3: "IND",
        flag: "🇮🇳",
    },
    {
        name: "Indonesia",
        dialCode: "+62",
        isoCode2: "ID",
        isoCode3: "IDN",
        flag: "🇮🇩",
    },
    {
        name: "Iran",
        dialCode: "+98",
        isoCode2: "IR",
        isoCode3: "IRN",
        flag: "🇮🇷",
    },
    {
        name: "Iraq",
        dialCode: "+964",
        isoCode2: "IQ",
        isoCode3: "IRQ",
        flag: "🇮🇶",
    },
    {
        name: "Ireland",
        dialCode: "+353",
        isoCode2: "IE",
        isoCode3: "IRL",
        flag: "🇮🇪",
    },
    {
        name: "Isle of Man",
        dialCode: "+441624",
        isoCode2: "IM",
        isoCode3: "IMN",
        flag: "🇮🇲",
    },
    {
        name: "Israel",
        dialCode: "+972",
        isoCode2: "IL",
        isoCode3: "ISR",
        flag: "🇮🇱",
    },
    {
        name: "Italy",
        dialCode: "+39",
        isoCode2: "IT",
        isoCode3: "ITA",
        flag: "🇮🇹",
    },
    {
        name: "Ivory Coast",
        dialCode: "+225",
        isoCode2: "CI",
        isoCode3: "CIV",
        flag: "🇨🇮",
    },
    {
        name: "Jamaica",
        dialCode: "+1876",
        isoCode2: "JM",
        isoCode3: "JAM",
        flag: "🇯🇲",
    },
    {
        name: "Japan",
        dialCode: "+81",
        isoCode2: "JP",
        isoCode3: "JPN",
        flag: "🇯🇵",
    },
    {
        name: "Jersey",
        dialCode: "+441534",
        isoCode2: "JE",
        isoCode3: "JEY",
        flag: "🇯🇪",
    },
    {
        name: "Jordan",
        dialCode: "+962",
        isoCode2: "JO",
        isoCode3: "JOR",
        flag: "🇯🇴",
    },
    {
        name: "Kazakhstan",
        dialCode: "+7",
        isoCode2: "KZ",
        isoCode3: "KAZ",
        flag: "🇰🇿",
    },
    {
        name: "Kenya",
        dialCode: "+254",
        isoCode2: "KE",
        isoCode3: "KEN",
        flag: "🇰🇪",
    },
    {
        name: "Kiribati",
        dialCode: "+686",
        isoCode2: "KI",
        isoCode3: "KIR",
        flag: "🇰🇮",
    },
    {
        name: "Kosovo",
        dialCode: "+383",
        isoCode2: "XK",
        isoCode3: "XKX",
        flag: "🇽🇰",
    },
    {
        name: "Kuwait",
        dialCode: "+965",
        isoCode2: "KW",
        isoCode3: "KWT",
        flag: "🇰🇼",
    },
    {
        name: "Kyrgyzstan",
        dialCode: "+996",
        isoCode2: "KG",
        isoCode3: "KGZ",
        flag: "🇰🇬",
    },
    {
        name: "Laos",
        dialCode: "+856",
        isoCode2: "LA",
        isoCode3: "LAO",
        flag: "🇱🇦",
    },
    {
        name: "Latvia",
        dialCode: "+371",
        isoCode2: "LV",
        isoCode3: "LVA",
        flag: "🇱🇻",
    },
    {
        name: "Lebanon",
        dialCode: "+961",
        isoCode2: "LB",
        isoCode3: "LBN",
        flag: "🇱🇧",
    },
    {
        name: "Lesotho",
        dialCode: "+266",
        isoCode2: "LS",
        isoCode3: "LSO",
        flag: "🇱🇸",
    },
    {
        name: "Liberia",
        dialCode: "+231",
        isoCode2: "LR",
        isoCode3: "LBR",
        flag: "🇱🇷",
    },
    {
        name: "Libya",
        dialCode: "+218",
        isoCode2: "LY",
        isoCode3: "LBY",
        flag: "🇱🇾",
    },
    {
        name: "Liechtenstein",
        dialCode: "+423",
        isoCode2: "LI",
        isoCode3: "LIE",
        flag: "🇱🇮",
    },
    {
        name: "Lithuania",
        dialCode: "+370",
        isoCode2: "LT",
        isoCode3: "LTU",
        flag: "🇱🇹",
    },
    {
        name: "Luxembourg",
        dialCode: "+352",
        isoCode2: "LU",
        isoCode3: "LUX",
        flag: "🇱🇺",
    },
    {
        name: "Macau",
        dialCode: "+853",
        isoCode2: "MO",
        isoCode3: "MAC",
        flag: "🇲🇴",
    },
    {
        name: "Macedonia",
        dialCode: "+389",
        isoCode2: "MK",
        isoCode3: "MKD",
        flag: "🇲🇰",
    },
    {
        name: "Madagascar",
        dialCode: "+261",
        isoCode2: "MG",
        isoCode3: "MDG",
        flag: "🇲🇬",
    },
    {
        name: "Malawi",
        dialCode: "+265",
        isoCode2: "MW",
        isoCode3: "MWI",
        flag: "🇲🇼",
    },
    {
        name: "Malaysia",
        dialCode: "+60",
        isoCode2: "MY",
        isoCode3: "MYS",
        flag: "🇲🇾",
    },
    {
        name: "Maldives",
        dialCode: "+960",
        isoCode2: "MV",
        isoCode3: "MDV",
        flag: "🇲🇻",
    },
    {
        name: "Mali",
        dialCode: "+223",
        isoCode2: "ML",
        isoCode3: "MLI",
        flag: "🇲🇱",
    },
    {
        name: "Malta",
        dialCode: "+356",
        isoCode2: "MT",
        isoCode3: "MLT",
        flag: "🇲🇹",
    },
    {
        name: "Marshall Islands",
        dialCode: "+692",
        isoCode2: "MH",
        isoCode3: "MHL",
        flag: "🇲🇭",
    },
    {
        name: "Mauritania",
        dialCode: "+222",
        isoCode2: "MR",
        isoCode3: "MRT",
        flag: "🇲🇷",
    },
    {
        name: "Mauritius",
        dialCode: "+230",
        isoCode2: "MU",
        isoCode3: "MUS",
        flag: "🇲🇺",
    },
    {
        name: "Mayotte",
        dialCode: "+262",
        isoCode2: "YT",
        isoCode3: "MYT",
        flag: "🇾🇹",
    },
    {
        name: "Mexico",
        dialCode: "+52",
        isoCode2: "MX",
        isoCode3: "MEX",
        flag: "🇲🇽",
    },
    {
        name: "Micronesia",
        dialCode: "+691",
        isoCode2: "FM",
        isoCode3: "FSM",
        flag: "🇫🇲",
    },
    {
        name: "Moldova",
        dialCode: "+373",
        isoCode2: "MD",
        isoCode3: "MDA",
        flag: "🇲🇩",
    },
    {
        name: "Monaco",
        dialCode: "+377",
        isoCode2: "MC",
        isoCode3: "MCO",
        flag: "🇲🇨",
    },
    {
        name: "Mongolia",
        dialCode: "+976",
        isoCode2: "MN",
        isoCode3: "MNG",
        flag: "🇲🇳",
    },
    {
        name: "Montenegro",
        dialCode: "+382",
        isoCode2: "ME",
        isoCode3: "MNE",
        flag: "🇲🇪",
    },
    {
        name: "Montserrat",
        dialCode: "+1664",
        isoCode2: "MS",
        isoCode3: "MSR",
        flag: "🇲🇸",
    },
    {
        name: "Morocco",
        dialCode: "+212",
        isoCode2: "MA",
        isoCode3: "MAR",
        flag: "🇲🇦",
    },
    {
        name: "Mozambique",
        dialCode: "+258",
        isoCode2: "MZ",
        isoCode3: "MOZ",
        flag: "🇲🇿",
    },
    {
        name: "Myanmar",
        dialCode: "+95",
        isoCode2: "MM",
        isoCode3: "MMR",
        flag: "🇲🇲",
    },
    {
        name: "Namibia",
        dialCode: "+264",
        isoCode2: "NA",
        isoCode3: "NAM",
        flag: "🇳🇦",
    },
    {
        name: "Nauru",
        dialCode: "+674",
        isoCode2: "NR",
        isoCode3: "NRU",
        flag: "🇳🇷",
    },
    {
        name: "Nepal",
        dialCode: "+977",
        isoCode2: "NP",
        isoCode3: "NPL",
        flag: "🇳🇵",
    },
    {
        name: "Netherlands",
        dialCode: "+31",
        isoCode2: "NL",
        isoCode3: "NLD",
        flag: "🇳🇱",
    },
    {
        name: "Netherlands Antilles",
        dialCode: "+599",
        isoCode2: "AN",
        isoCode3: "ANT",
    },
    {
        name: "New Caledonia",
        dialCode: "+687",
        isoCode2: "NC",
        isoCode3: "NCL",
        flag: "🇳🇨",
    },
    {
        name: "New Zealand",
        dialCode: "+64",
        isoCode2: "NZ",
        isoCode3: "NZL",
        flag: "🇳🇿",
    },
    {
        name: "Nicaragua",
        dialCode: "+505",
        isoCode2: "NI",
        isoCode3: "NIC",
        flag: "🇳🇮",
    },
    {
        name: "Niger",
        dialCode: "+227",
        isoCode2: "NE",
        isoCode3: "NER",
        flag: "🇳🇪",
    },
    {
        name: "Nigeria",
        dialCode: "+234",
        isoCode2: "NG",
        isoCode3: "NGA",
        flag: "🇳🇬",
    },
    {
        name: "Niue",
        dialCode: "+683",
        isoCode2: "NU",
        isoCode3: "NIU",
        flag: "🇳🇺",
    },
    {
        name: "North Korea",
        dialCode: "+850",
        isoCode2: "KP",
        isoCode3: "PRK",
        flag: "🇰🇵",
    },
    {
        name: "Northern Mariana Islands",
        dialCode: "+1670",
        isoCode2: "MP",
        isoCode3: "MNP",
        flag: "🇲🇵",
    },
    {
        name: "Norway",
        dialCode: "+47",
        isoCode2: "NO",
        isoCode3: "NOR",
        flag: "🇳🇴",
    },
    {
        name: "Oman",
        dialCode: "+968",
        isoCode2: "OM",
        isoCode3: "OMN",
        flag: "🇴🇲",
    },
    {
        name: "Pakistan",
        dialCode: "+92",
        isoCode2: "PK",
        isoCode3: "PAK",
        flag: "🇵🇰",
    },
    {
        name: "Palau",
        dialCode: "+680",
        isoCode2: "PW",
        isoCode3: "PLW",
        flag: "🇵🇼",
    },
    {
        name: "Palestine",
        dialCode: "+970",
        isoCode2: "PS",
        isoCode3: "PSE",
        flag: "🇵🇸",
    },
    {
        name: "Panama",
        dialCode: "+507",
        isoCode2: "PA",
        isoCode3: "PAN",
        flag: "🇵🇦",
    },
    {
        name: "Papua New Guinea",
        dialCode: "+675",
        isoCode2: "PG",
        isoCode3: "PNG",
        flag: "🇵🇬",
    },
    {
        name: "Paraguay",
        dialCode: "+595",
        isoCode2: "PY",
        isoCode3: "PRY",
        flag: "🇵🇾",
    },
    {
        name: "Peru",
        dialCode: "+51",
        isoCode2: "PE",
        isoCode3: "PER",
        flag: "🇵🇪",
    },
    {
        name: "Philippines",
        dialCode: "+63",
        isoCode2: "PH",
        isoCode3: "PHL",
        flag: "🇵🇭",
    },
    {
        name: "Pitcairn",
        dialCode: "+64",
        isoCode2: "PN",
        isoCode3: "PCN",
        flag: "🇵🇳",
    },
    {
        name: "Poland",
        dialCode: "+48",
        isoCode2: "PL",
        isoCode3: "POL",
        flag: "🇵🇱",
    },
    {
        name: "Portugal",
        dialCode: "+351",
        isoCode2: "PT",
        isoCode3: "PRT",
        flag: "🇵🇹",
    },
    {
        name: "Qatar",
        dialCode: "+974",
        isoCode2: "QA",
        isoCode3: "QAT",
        flag: "🇶🇦",
    },
    {
        name: "Republic of the Congo",
        dialCode: "+242",
        isoCode2: "CG",
        isoCode3: "COG",
        flag: "🇨🇬",
    },
    {
        name: "Reunion",
        dialCode: "+262",
        isoCode2: "RE",
        isoCode3: "REU",
        flag: "🇷🇪",
    },
    {
        name: "Romania",
        dialCode: "+40",
        isoCode2: "RO",
        isoCode3: "ROU",
        flag: "🇷🇴",
    },
    {
        name: "Russia",
        dialCode: "+7",
        isoCode2: "RU",
        isoCode3: "RUS",
        flag: "🇷🇺",
    },
    {
        name: "Rwanda",
        dialCode: "+250",
        isoCode2: "RW",
        isoCode3: "RWA",
        flag: "🇷🇼",
    },
    {
        name: "Saint Barthelemy",
        dialCode: "+590",
        isoCode2: "BL",
        isoCode3: "BLM",
        flag: "🇧🇱",
    },
    {
        name: "Saint Helena",
        dialCode: "+290",
        isoCode2: "SH",
        isoCode3: "SHN",
        flag: "🇸🇭",
    },
    {
        name: "Saint Kitts and Nevis",
        dialCode: "+1869",
        isoCode2: "KN",
        isoCode3: "KNA",
        flag: "🇰🇳",
    },
    {
        name: "Saint Lucia",
        dialCode: "+1758",
        isoCode2: "LC",
        isoCode3: "LCA",
        flag: "🇱🇨",
    },
    {
        name: "Saint Martin",
        dialCode: "+590",
        isoCode2: "MF",
        isoCode3: "MAF",
        flag: "🇲🇫",
    },
    {
        name: "Saint Pierre and Miquelon",
        dialCode: "+508",
        isoCode2: "PM",
        isoCode3: "SPM",
        flag: "🇵🇲",
    },
    {
        name: "Saint Vincent and the Grenadines",
        dialCode: "+1784",
        isoCode2: "VC",
        isoCode3: "VCT",
        flag: "🇻🇨",
    },
    {
        name: "Samoa",
        dialCode: "+685",
        isoCode2: "WS",
        isoCode3: "WSM",
        flag: "🇼🇸",
    },
    {
        name: "San Marino",
        dialCode: "+378",
        isoCode2: "SM",
        isoCode3: "SMR",
        flag: "🇸🇲",
    },
    {
        name: "Sao Tome and Principe",
        dialCode: "+239",
        isoCode2: "ST",
        isoCode3: "STP",
        flag: "🇸🇹",
    },
    {
        name: "Saudi Arabia",
        dialCode: "+966",
        isoCode2: "SA",
        isoCode3: "SAU",
        flag: "🇸🇦",
    },
    {
        name: "Senegal",
        dialCode: "+221",
        isoCode2: "SN",
        isoCode3: "SEN",
        flag: "🇸🇳",
    },
    {
        name: "Serbia",
        dialCode: "+381",
        isoCode2: "RS",
        isoCode3: "SRB",
        flag: "🇷🇸",
    },
    {
        name: "Seychelles",
        dialCode: "+248",
        isoCode2: "SC",
        isoCode3: "SYC",
        flag: "🇸🇨",
    },
    {
        name: "Sierra Leone",
        dialCode: "+232",
        isoCode2: "SL",
        isoCode3: "SLE",
        flag: "🇸🇱",
    },
    {
        name: "Singapore",
        dialCode: "+65",
        isoCode2: "SG",
        isoCode3: "SGP",
        flag: "🇸🇬",
    },
    {
        name: "Sint Maarten",
        dialCode: "+1721",
        isoCode2: "SX",
        isoCode3: "SXM",
        flag: "🇸🇽",
    },
    {
        name: "Slovakia",
        dialCode: "+421",
        isoCode2: "SK",
        isoCode3: "SVK",
        flag: "🇸🇰",
    },
    {
        name: "Slovenia",
        dialCode: "+386",
        isoCode2: "SI",
        isoCode3: "SVN",
        flag: "🇸🇮",
    },
    {
        name: "Solomon Islands",
        dialCode: "+677",
        isoCode2: "SB",
        isoCode3: "SLB",
        flag: "🇸🇧",
    },
    {
        name: "Somalia",
        dialCode: "+252",
        isoCode2: "SO",
        isoCode3: "SOM",
        flag: "🇸🇴",
    },
    {
        name: "South Africa",
        dialCode: "+27",
        isoCode2: "ZA",
        isoCode3: "ZAF",
        flag: "🇿🇦",
    },
    {
        name: "South Korea",
        dialCode: "+82",
        isoCode2: "KR",
        isoCode3: "KOR",
        flag: "🇰🇷",
    },
    {
        name: "South Sudan",
        dialCode: "+211",
        isoCode2: "SS",
        isoCode3: "SSD",
        flag: "🇸🇸",
    },
    {
        name: "Spain",
        dialCode: "+34",
        isoCode2: "ES",
        isoCode3: "ESP",
        flag: "🇪🇸",
    },
    {
        name: "Sri Lanka",
        dialCode: "+94",
        isoCode2: "LK",
        isoCode3: "LKA",
        flag: "🇱🇰",
    },
    {
        name: "Sudan",
        dialCode: "+249",
        isoCode2: "SD",
        isoCode3: "SDN",
        flag: "🇸🇩",
    },
    {
        name: "Suriname",
        dialCode: "+597",
        isoCode2: "SR",
        isoCode3: "SUR",
        flag: "🇸🇷",
    },
    {
        name: "Svalbard and Jan Mayen",
        dialCode: "+47",
        isoCode2: "SJ",
        isoCode3: "SJM",
        flag: "🇸🇯",
    },
    {
        name: "Swaziland",
        dialCode: "+268",
        isoCode2: "SZ",
        isoCode3: "SWZ",
        flag: "🇸🇿",
    },
    {
        name: "Sweden",
        dialCode: "+46",
        isoCode2: "SE",
        isoCode3: "SWE",
        flag: "🇸🇪",
    },
    {
        name: "Switzerland",
        dialCode: "+41",
        isoCode2: "CH",
        isoCode3: "CHE",
        flag: "🇨🇭",
    },
    {
        name: "Syria",
        dialCode: "+963",
        isoCode2: "SY",
        isoCode3: "SYR",
        flag: "🇸🇾",
    },
    {
        name: "Taiwan",
        dialCode: "+886",
        isoCode2: "TW",
        isoCode3: "TWN",
        flag: "🇹🇼",
    },
    {
        name: "Tajikistan",
        dialCode: "+992",
        isoCode2: "TJ",
        isoCode3: "TJK",
        flag: "🇹🇯",
    },
    {
        name: "Tanzania",
        dialCode: "+255",
        isoCode2: "TZ",
        isoCode3: "TZA",
        flag: "🇹🇿",
    },
    {
        name: "Thailand",
        dialCode: "+66",
        isoCode2: "TH",
        isoCode3: "THA",
        flag: "🇹🇭",
    },
    {
        name: "Togo",
        dialCode: "+228",
        isoCode2: "TG",
        isoCode3: "TGO",
        flag: "🇹🇬",
    },
    {
        name: "Tokelau",
        dialCode: "+690",
        isoCode2: "TK",
        isoCode3: "TKL",
        flag: "🇹🇰",
    },
    {
        name: "Tonga",
        dialCode: "+676",
        isoCode2: "TO",
        isoCode3: "TON",
        flag: "🇹🇴",
    },
    {
        name: "Trinidad and Tobago",
        dialCode: "+1868",
        isoCode2: "TT",
        isoCode3: "TTO",
        flag: "🇹🇹",
    },
    {
        name: "Tunisia",
        dialCode: "+216",
        isoCode2: "TN",
        isoCode3: "TUN",
        flag: "🇹🇳",
    },
    {
        name: "Turkey",
        dialCode: "+90",
        isoCode2: "TR",
        isoCode3: "TUR",
        flag: "🇹🇷",
    },
    {
        name: "Turkmenistan",
        dialCode: "+993",
        isoCode2: "TM",
        isoCode3: "TKM",
        flag: "🇹🇲",
    },
    {
        name: "Turks and Caicos Islands",
        dialCode: "+1649",
        isoCode2: "TC",
        isoCode3: "TCA",
        flag: "🇹🇨",
    },
    {
        name: "Tuvalu",
        dialCode: "+688",
        isoCode2: "TV",
        isoCode3: "TUV",
        flag: "🇹🇻",
    },
    {
        name: "U.S. Virgin Islands",
        dialCode: "+1340",
        isoCode2: "VI",
        isoCode3: "VIR",
        flag: "🇻🇮",
    },
    {
        name: "Uganda",
        dialCode: "+256",
        isoCode2: "UG",
        isoCode3: "UGA",
        flag: "🇺🇬",
    },
    {
        name: "Ukraine",
        dialCode: "+380",
        isoCode2: "UA",
        isoCode3: "UKR",
        flag: "🇺🇦",
    },
    {
        name: "United Arab Emirates",
        dialCode: "+971",
        isoCode2: "AE",
        isoCode3: "ARE",
        flag: "🇦🇪",
    },
    {
        name: "United Kingdom",
        dialCode: "+44",
        isoCode2: "GB",
        isoCode3: "GBR",
        flag: "🇬🇧",
    },
    {
        name: "United States",
        dialCode: "+1",
        isoCode2: "US",
        isoCode3: "USA",
        flag: "🇺🇸",
    },
    {
        name: "Uruguay",
        dialCode: "+598",
        isoCode2: "UY",
        isoCode3: "URY",
        flag: "🇺🇾",
    },
    {
        name: "Uzbekistan",
        dialCode: "+998",
        isoCode2: "UZ",
        isoCode3: "UZB",
        flag: "🇺🇿",
    },
    {
        name: "Vanuatu",
        dialCode: "+678",
        isoCode2: "VU",
        isoCode3: "VUT",
        flag: "🇻🇺",
    },
    {
        name: "Vatican",
        dialCode: "+379",
        isoCode2: "VA",
        isoCode3: "VAT",
        flag: "🇻🇦",
    },
    {
        name: "Venezuela",
        dialCode: "+58",
        isoCode2: "VE",
        isoCode3: "VEN",
        flag: "🇻🇪",
    },
    {
        name: "Vietnam",
        dialCode: "+84",
        isoCode2: "VN",
        isoCode3: "VNM",
        flag: "🇻🇳",
    },
    {
        name: "Wallis and Futuna",
        dialCode: "+681",
        isoCode2: "WF",
        isoCode3: "WLF",
        flag: "🇼🇫",
    },
    {
        name: "Western Sahara",
        dialCode: "+212",
        isoCode2: "EH",
        isoCode3: "ESH",
        flag: "🇪🇭",
    },
    {
        name: "Yemen",
        dialCode: "+967",
        isoCode2: "YE",
        isoCode3: "YEM",
        flag: "🇾🇪",
    },
    {
        name: "Zambia",
        dialCode: "+260",
        isoCode2: "ZM",
        isoCode3: "ZMB",
        flag: "🇿🇲",
    },
    {
        name: "Zimbabwe",
        dialCode: "+263",
        isoCode2: "ZW",
        isoCode3: "ZWE",
        flag: "🇿🇼",
    },
    {
        name: "Dominican Republic",
        dialCode: "+1809",
        isoCode2: "DO",
        isoCode3: "DOM-0",
        flag: "🇩🇴",
    },
    {
        name: "Dominican Republic",
        dialCode: "+1829",
        isoCode2: "DO",
        isoCode3: "DOM-1",
        flag: "🇩🇴",
    },
    {
        name: "Dominican Republic",
        dialCode: "+1849",
        isoCode2: "DO",
        isoCode3: "DOM-2",
        flag: "🇩🇴",
    },
    {
        name: "Puerto Rico",
        dialCode: "+1787",
        isoCode2: "PR",
        isoCode3: "PRI-0",
        flag: "🇵🇷",
    },
    {
        name: "Puerto Rico",
        dialCode: "+1939",
        isoCode2: "PR",
        isoCode3: "PRI-1",
        flag: "🇵🇷",
    },
];

export const getCountryDialCode = (isoCode) => countries
    .find((country) => country.isoCode3 === isoCode || country.isoCode2 === isoCode || country.dialCode === isoCode)
    ?.dialCode || "";

export const startsWithLetters = (str) => /^[a-zA-Z]{3}/.test(str);

export const getDialCode = (number) => getCountryDialCode(number?.slice(0, 3));
export const getNumberWithoutDialCode = (number) => number?.slice(4);

export const parseCountryDialCode = (number) => `${getCountryDialCode(number?.slice(0, 3))} ${number?.slice(4)}`;
